import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { expensesApi } from 'src/Services/API';
import { MarkExpensesReimbursedDto } from 'src/Services/API/generated';

interface Options {
  onSuccess?: () => void;
}

export const useMarkExpensesReimbursed = (options?: Options) => {
  const { assetId } = useParams<{ assetId: string }>();
  const queryClient = useQueryClient();

  return useMutation(
    (data: MarkExpensesReimbursedDto) => {
      if (!assetId) throw new Error('Asset ID is missing');
      return expensesApi.expensesControllerMarkReimbursed(assetId, data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-expenses', assetId]);
        queryClient.invalidateQueries(['money-transfers', assetId]);
        queryClient.invalidateQueries(['fetch-expense-stats']);
        queryClient.invalidateQueries(['fetch-expense-balance', assetId]);
        queryClient.invalidateQueries(['fetch-personal-wallet', assetId]);
        queryClient.invalidateQueries(['asset-stats', assetId]);
        options?.onSuccess?.();
      },
    }
  );
};
